import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { httpGet, httpPost } from './api/request'

Vue.use(ElementUI)

Vue.config.productionTip = false

Vue.prototype.$http = {
  get: httpGet,
  post: httpPost
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
